export class VitalSignRootService {
  static currentTab = '';
  static isAllowEdit = true;
}